import { useMemo, useState } from 'react'
import { NavLink } from 'react-router-dom'

import { useAppSelector } from '../../../store/hooks'

import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'

import { IntegrationExportButton } from '../../../components/IntegrationExportButton/IntegrationExportButton'
import buttonStyles from '../../../components/Button/Button.module.scss'
import { UserAvatar } from '../../../components/UserAvatar/UserAvatar'

import { canCreateOrUpdateContact, IntegrationServiceId } from '../../../common/integrations'
import { UpdateExternalDocumentContactModal } from '../../UpdateExternalContact/UpdateExternalContact'
import { DocumentRecord } from '../../../models/Document'
import { User } from '../../../models/User'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetMeQuery } from '../../../store/user/user'

interface DocumentSummaryContactsProps {
  document: DocumentRecord
  contact: User
}

export const DocumentSummaryContacts: React.FC<DocumentSummaryContactsProps> = ({ document, contact }) => {
  const accountId = useAppSelector(selectAccountId)

  const { data: currentUser } = useGetMeQuery({ accountId })

  const [selectedIntegrationType, setSelectedIntegrationType] = useState<IntegrationServiceId | null>(null)

  const contactUpdateSupportedUserIntegrations = useMemo(
    () => currentUser?.integrations?.filter(({ serviceId }) => canCreateOrUpdateContact(serviceId as IntegrationServiceId, contact.integrations)) ?? [],
    [currentUser, contact.integrations],
  )

  const handleHideModal = () => {
    setSelectedIntegrationType(null)
  }

  return (
    <>
      {selectedIntegrationType ? (
        <UpdateExternalDocumentContactModal
          serviceId={selectedIntegrationType}
          user={contact}
          documentId={document.id}
          files={document.files}
          show={true}
          onCancel={handleHideModal}
          onSave={handleHideModal}
        />
      ) : null}
      <div className='p-4 zocks-border-0.5 border zocks-border-color-gray-300 d-flex flex-column gap-4'>
        <div className='d-flex align-items-center justify-content-between'>
          <span className='paragraph-large bold'>Clients</span>
        </div>
        <div className='d-flex flex-column gap-4'>
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <div className='d-flex align-items-center gap-3'>
              <UserAvatar
                width='1.5rem'
                height='1.5rem'
                fontSize='0.75rem'
                className='zocks-bg-color-gray-900 zocks-text-white'
                useInitials={true}
                initialLetters={contact.name ? contact.name[0] : ''}
              />
              <NavLink
                className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium `}
                to={`/library/manage-contacts/contacts/${contact.id}`}
                target='_blank'
              >
                <div className='paragraph-medium-extended bold text-truncate mw-100'>
                  <div className='text-truncate'>{getUserDisplayName(contact)}</div>
                </div>
              </NavLink>
            </div>
            <div className='d-flex align-items-center gap-2'>
              {contactUpdateSupportedUserIntegrations.map(({ serviceId }) => (
                <IntegrationExportButton key={serviceId} serviceId={serviceId} onClick={() => setSelectedIntegrationType(serviceId as IntegrationServiceId)} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
